import { render, staticRenderFns } from "./EWTrxActivityTypeShow.vue?vue&type=template&id=ba4c8b7c&"
import script from "./EWTrxActivityTypeShow.vue?vue&type=script&lang=js&"
export * from "./EWTrxActivityTypeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports